module.exports = __webpack_public_path__ + "system/fonts/fc-icons.0a7f1443.woff";